import { DictUtil } from 'jczh-ui'

// 评审进度类型
export const reviewProcessTypeDict = new DictUtil({
  LEADER: { label: '组长推荐', value: 1, routeName: 'LeaderRecommend' },
  REVIEW: { label: '评标', value: 2, routeName: 'ReviewSession' },
  REPORT: { label: '评审报告', value: 3, routeName: 'ReviewReport' },
  REPORT_FIRST: {
    label: '一阶段评审报告',
    value: 4,
    routeName: 'ReviewReportFirst'
  }
})

// 评审进度状态
export const reviewProcessStatusDict = new DictUtil({
  NOT_STARTED: { label: '未开始', value: 0 },
  IN: { label: '进行中', value: 1 },
  COMPLETED: { label: '已完成', value: 2 }
})

// 评审办法状态
export const reviewWayStatusDict = new DictUtil({
  NOT_STARTED: { label: '未开始', value: 0, subTitle: '未开始' },
  IN: { label: '评审中', value: 1, subTitle: '未提交-未汇总' },
  SUMMARY: { label: '已汇总', value: 2, subTitle: '已提交-已汇总' },
  RESTART: { label: '已重新评审', value: 3, subTitle: '未提交-未汇总' }
})

// 投标单位评审状态
export const companyReviewStatusDict = new DictUtil({
  // 待评
  PENDING: { label: '待评', value: 0, type: 'primary' },
  // 已评
  COMPLETED: { label: '已评', value: 1, type: 'info' },
  // 已提交
  SUBMITTED: { label: '已评', value: 2, type: 'info' }
})

/* *** 专家询标相关字典 *** */
// 消息类型
export const messageTypeDict = new DictUtil({
  ASK: { label: '询标', value: 1 },
  ANSWER: { label: '询标回复', value: 2 }
})

// 消息状态
export const messageStatusDict = new DictUtil({
  SENT: { label: '已发送', value: 1 },
  READ: { label: '已读', value: 2 }
})

/* *** 投标人报价相关字典 *** */
// 投标人报价状态
export const bidderQuoteStatusDict = new DictUtil({
  INIT: { label: '初始化', value: 0 },
  IN: { label: '报价中', value: 1 },
  END: { label: '报价完成', value: 2 }
})

// 投标人报价轮次状态
export const bidderQuoteRoundStatusDict = new DictUtil({
  NOT_START: { label: '未开始', value: 0 },
  IN: { label: '报价中', value: 1 },
  END: { label: '报价已截止', value: 2 }
})

// 投标人报价文件制作方式
export const bidderQuoteFileMakeMethodDict = new DictUtil({
  APP: { label: '上传已签章报价', value: 1 },
  ATTACHMENT: { label: '本地上传报价附件', value: 2 }
})

/* *** 投标人询标相关字典 *** */
// 询标消息类型
export const bidderMessageTypeDict = new DictUtil({
  ASK: { label: '询标', value: 1 },
  ANSWER: { label: '询标回复', value: 2 }
})

// 询标消息状态
export const bidderMessageStatusDict = new DictUtil({
  HAVE_SENT: { label: '已发送', value: 1 },
  HAVE_READ: { label: '已读', value: 2 }
})

/* *** 评标报告相关字典 *** */
// 报告状态
export const reviewReportStatusDict = new DictUtil({
  INIT: { label: '初始化', value: 0 },
  PENDING: { label: '待生成', value: 1 },
  IN: { label: '生成中', value: 2 },
  SUCCESS: { label: '创建完成', value: 3 },
  FAIL: { label: '创建失败', value: 4 },
  RESTART: { label: '已重新生成', value: 5 }
})

// 报告目录类型
export const reviewReportCatalogTypeDict = new DictUtil({
  1: { label: '总分汇总表', value: 1 },
  2: { label: '评标报告', value: 2 },
  3: { label: '开标一览表', value: 3 },
  4: { label: '评审办法汇总表', value: 4 },
  5: { label: '评审办法明细表', value: 5 },
  6: { label: '评审办法明细表-专家', value: 6 },
  7: { label: '评审询标记录表', value: 7 },
  8: { label: '报价记录表', value: 8 },
  9: { label: '商务开标一览表', value: 9 },
  10: { label: '报价开标一览表', value: 10 },
  11: { label: '最高报价排序表', value: 11 },
  12: { label: '最低报价排序表', value: 12 },
  13: { label: '废标记录表', value: 13 },
  14: { label: '专家名单', value: 14 },
  15: { label: '候选人推荐表', value: 15 },
  16: { label: '评审点汇总表', value: 16 }
})

// 报告目录状态
export const reviewReportCatalogStatusDict = new DictUtil({
  INIT: { label: '初始化', value: 0 },
  IN: { label: '生成中', value: 1 },
  SUCCESS: { label: '创建完成', value: 2 },
  FAIL: { label: '创建失败', value: 3 }
})

// 报告目录查询类型
export const reviewReportViewScopeTypeDict = new DictUtil({
  ALL: { label: '全部', value: 0 },
  LIMITED: { label: '符合性、资格、价格分汇总无需专家明细表', value: 1 }
})

// 聊天组件发送消息类型
export const IMmessageDict = new DictUtil({
  TEXT: { label: '文本', value: 1 },
  FILE: { label: '附件', value: 2 },
  IMG: { label: '图片', value: 3 }
})

// 报告签名状态
export const reviewReportSignStatusDict = new DictUtil({
  INIT: { label: '未签名', value: 0 },
  IN: { label: '签名中', value: 1 },
  SUCCESS: { label: '签名完成', value: 2 }
})

// 报告生成状态
export const reportGenerateStatusDict = new DictUtil({
  PENDING: { label: '等待中', value: reviewReportCatalogStatusDict.INIT.value },
  IN: { label: '生成中', value: reviewReportCatalogStatusDict.IN.value },
  SUCCESS: {
    label: '已完成',
    value: reviewReportCatalogStatusDict.SUCCESS.value
  },
  FAIL: {
    label: '生成失败，请重试',
    value: reviewReportCatalogStatusDict.FAIL.value
  }
})

// 报告模板类型
export const reportTemplateTypeDict = new DictUtil({
  DEFAULT: { label: '默认评审模板', value: 'default' },
  COMPARISON: { label: '比选评审模板', value: 'comparison' },
  NEGOTIATION: { label: '竞争性谈判评审模板', value: 'negotiation' },
  CONSULT: { label: '竞争性磋商模板', value: 'consult' }
})

// 评审方式
export const reviewMethodDict = new DictUtil({
  PASS_OR_NOT: { label: '是否通过', value: 1 },
  SCORE: { label: '打分', value: 2 }
})
